import { createSlice } from '@reduxjs/toolkit';

import { licenseReducer, licenseState } from './license';

/** Plugin Leadtools Slice. */
export const pluginLeadtoolsSlice = createSlice({
  name: 'plugin_leadtools',
  initialState: {
    ...licenseState,
  },
  reducers: {
    ...licenseReducer,
  },
});

/** Plugin Leadtools Slice Actions. */
export const pluginLeadtoolsSliceActions = pluginLeadtoolsSlice.actions;
